import React, { createContext, useContext, useRef, useState } from 'react';

export type MessagesListRefsState = {
	scrollContainerRef: React.RefObject<HTMLDivElement | null>;
	unreadMessageLineRef: HTMLDivElement | null;
	setUnreadMessageLineRef: (el: HTMLDivElement | null) => void;
};

const messagesListRefsContext = createContext<MessagesListRefsState | null>(
	null,
);

export const useMessagesListRefs = () => {
	const ctx = useContext(messagesListRefsContext);
	if (!ctx)
		throw new Error(
			'useMessagesListRefs must be used within MessagesListRefsProvider',
		);
	return ctx;
};

export const MessagesListRefsProvider = ({
	children,
}: React.PropsWithChildren) => {
	const scrollContainerRef = useRef<HTMLDivElement | null>(null);
	const [unreadMessageLineRef, setUnreadMessageLineRef] =
		useState<HTMLDivElement | null>(null);

	return (
		<messagesListRefsContext.Provider
			value={{
				scrollContainerRef,
				unreadMessageLineRef,
				setUnreadMessageLineRef,
			}}
		>
			{children}
		</messagesListRefsContext.Provider>
	);
};
